import {
  ArrowRightOutlined,
  EditOutlined,
  InfoCircleOutlined,
  RetweetOutlined,
} from '@ant-design/icons';
import { Card, Col, Form, Popover, Row, Tag } from 'antd';
import React, { useState } from 'react';

import ButtonLink from 'components/theme_components/ButtonLink';
import DataGrid from 'components/theme_components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DualPieChart from 'components/theme_components/PieChart';
import { FinCTListResponse } from 'services/fincontract';
import { FormInstance } from 'antd/lib/form';
import GeneralData from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyCreation/components/GeneralData';
import GeneralDataMoralTP from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyCreation/components/GeneralDataMoralTP';
import GetLabel from 'DisplayFramework/components/GetLabel';
import HeroTitle from 'components/theme_components/HeroTitle';
import ProgressBarChart from 'components/theme_components/ProgressBarChart';
import StatCard from 'components/theme_components/StatCard';
import ThirdPartySearch from 'pages/ThirdParty/TpList';
import Title from 'components/Title';

export type DashboardProps = {
  form: FormInstance;
  color: string;
  itemsCompanyHierarchyTree?: any[];
  onSave?: (values: any) => void;
  onEdit?: () => void;
  isEditing?: boolean;
  tptype?: string;
  percentageConsumedVN: number;
  percentageConsumedVO: number;
  percentageConsumedVD: number;
};

const Dashboard = ({
  form,
  color,
  itemsCompanyHierarchyTree,
  onSave,
  onEdit,
  isEditing,
  tptype,
  percentageConsumedVN,
  percentageConsumedVO,
  percentageConsumedVD,
}: DashboardProps) => {
  const columns = [
    {
      dataIndex: 'propreference',
      width: '10%',
    },
    {
      dataIndex: 'ctreference',
      width: '10%',
    },

    {
      dataIndex: 'prcode',
      width: '10%',
    },
    {
      comcode: 'offeridlabel',
      dataIndex: 'offerid',
      width: '10%',
    },
    {
      dataIndex: 'clientname',
      width: '10%',
    },
    {
      dataIndex: 'initialamount',
      width: '10%',
    },
    {
      dataIndex: 'remainingamount',
      width: '10%',
    },
  ];

  const getStatusColor = (tpstatus: string) => {
    let color = 'green';
    if (
      tpstatus == 'CREATESYNC' ||
      tpstatus == 'UPDATESYNC' ||
      tpstatus == 'INIT'
    ) {
      color = 'green';
    } else {
      color = 'red';
    }
    return color;
  };

  return !isEditing ? (
    <div>
      <HeroTitle
        isEditing={isEditing}
        onEdit={() => onEdit && onEdit()}
        form={form}
        color={color}
        itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
        tptype={tptype}
      />

      <div className="pl-6 pr-6 pt-9 pb-4">
        <Row justify="end" style={{ marginBottom: 10 }}>
          <Tag
            color={getStatusColor(form.getFieldValue('tpstatus'))}
            style={{ fontSize: 15 }}
          >
            {' '}
            <Popover content={form.getFieldValue('tpfree1')}>
              <InfoCircleOutlined />
            </Popover>{' '}
            {form.getFieldValue('tpstatuslabel')}
          </Tag>
        </Row>
        <Row justify="space-between">
          <Col style={{ width: '18%' }}>
            <StatCard
              title="Paiment de jour (€)"
              value={''}
              variant="secondary"
            />
          </Col>
          <Col style={{ width: '18%' }}>
            <StatCard
              title="Nb. châssis en franchise"
              value={''}
              variant="green"
            />
          </Col>
          <Col style={{ width: '18%' }}>
            <StatCard
              title="Nb. châssis en taux 1"
              value={''}
              variant="primary"
            />
          </Col>
          <Col style={{ width: '18%' }}>
            <StatCard
              title="Nb. châssis en taux 2"
              value={''}
              variant="warning"
            />
          </Col>
          <Col style={{ width: '18%' }}>
            <StatCard
              title="Nb. châssis en taux 3"
              value={''}
              variant="error"
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 40 }} justify="space-between">
          <Col style={{ width: '59%' }}>
            <Row className="d-flex justify-between align-center mb-2">
              <Col>
                <Title
                  comcode="Derniers châssis  immatriculés"
                  level={3}
                  className="font-familly-sans-serif mb-0"
                />
              </Col>
              <Col>
                <Row justify="end">
                  <ButtonLink comcode=">5 jours" className="btn-dashboard" />
                  <ButtonLink comcode="5 jours" className="btn-dashboard" />
                  <ButtonLink comcode="4 jours" className="btn-dashboard" />
                  <Col
                    className="text-right"
                    style={{
                      marginLeft: 10,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <p className="d-flex align-items-center font-size-15 pt-1 pl-3 pr-3">
                      {' '}
                      <GetLabel label="VoirTout" />
                      <ArrowRightOutlined className="color-orange ml-2" />
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* <ThirdPartySearch hideFilters isModal="true" className='no-border-radius' /> */}
          </Col>
          <Col style={{ width: '38.5%' }} className="d-flex align-center">
            <p className="font-size-18 font-weight-500 d-flex align-center">
              <GetLabel label="Limites consommées" />
              <ArrowRightOutlined className="color-orange ml-5" />
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }} justify="space-between">
          <Col
            style={{ width: '59%' }}
            className="no-border-radius no-padding "
          >
            <Card bordered={false} style={{ padding: 0 }}>
              <DataGrid
                dataSource={[]}
                columns={columns}
                rowKey={''}
                scroll={{ x: 1000, y: 360 }}
                pagination={{ pageSize: 10 }}
                hideFilters
                hideTitle
              />
            </Card>
          </Col>
          <Col style={{ width: '38.5%' }} className="no-border-radius">
            <Card bordered={false}>
              <Row
                justify="center"
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  gap: 34,
                  padding: '0.25rem 1rem',
                }}
              >
                <ProgressBarChart
                  percentageValue={Number(percentageConsumedVN.toFixed(2))}
                  size={145}
                  label="VN"
                  color="#3B55B9"
                />
                <ProgressBarChart
                  percentageValue={Number(percentageConsumedVO.toFixed(2))}
                  size={145}
                  label="VO"
                  color="#3B55B9"
                />
                <ProgressBarChart
                  percentageValue={Number(percentageConsumedVD.toFixed(2))}
                  size={145}
                  label="VD"
                  color="#3B55B9"
                />
              </Row>
            </Card>
            <div className="font-size-18 font-familly-sans-serif mt-8 font-weight-500">
              <p className="d-flex align-center">
                {' '}
                <GetLabel label="Garding" />
                <ArrowRightOutlined className="color-orange ml-5" />
              </p>
              <Row className="mt-7 ml-5 mr-5">
                <Col span={3} className="mr-9">
                  {' '}
                  {/*  ca sera in list mapper */}
                  {/* colors should be from red to yellow to teal hex codes= {C-: #D34444, C+: #e2632d, D-: #f18216, D+: #ffa200, B-: #c79217, B+: #8f822e, A-: #577245, A+: #20635d} */}
                  <div className="align-center grading">
                    <Tag
                      color="#e2632d"
                      className=" tag-status  tag-status-default align-center"
                    >
                      {' '}
                      <Title
                        level={2}
                        comcode="C+"
                        className="text-white mb-0"
                      />{' '}
                    </Tag>
                    <p className="text-center font-size-15 mt-3">BPF</p>
                  </div>
                </Col>
                <Col span={2} className="mr-9">
                  {' '}
                  {/*  ca sera in list mapper */}
                  {/* <div className="align-center grading">
                    <Tag
                      color="#20635d"
                      className=" tag-status align-center"
                    >
                      {' '}
                      <Title
                        level={2}
                        comcode="A+"
                        className="text-white mb-0"
                      />{' '}
                    </Tag>
                    <p className="text-center font-size-15 mt-3">BNPP</p>
                  </div> */}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <div className="bg-color-gray">
      <HeroTitle
        display
        title="updatemoralTp"
        form={form}
        color={color}
        isEditing={isEditing}
      />
      <GeneralData
        form={form}
        required
        onEdit={() => onEdit && onEdit()}
        onSave={(values) => {
          onSave && onSave(values);
        }}
        tptype={tptype}
      />
    </div>
  );
};

export default Dashboard;
